import { TrendingUp, Target, BarChart3, AlertTriangle, Package, Activity } from "lucide-react";

function formatNum(n) {
  if (n >= 10000000) return `${(n / 10000000).toFixed(1)}Cr`;
  if (n >= 100000) return `${(n / 100000).toFixed(1)}L`;
  if (n >= 1000) return `${(n / 1000).toFixed(1)}K`;
  return n.toString();
}

const cards = (kpi) => [
  { label: "Total Revenue (YTD)", value: `INR ${formatNum(kpi.total_revenue)}`, sub: `Target: INR ${formatNum(kpi.revenue_target)}`, icon: TrendingUp, color: "text-emerald-400", bg: "bg-emerald-500/10 border-emerald-500/20" },
  { label: "Revenue Achievement", value: `${kpi.revenue_achievement}%`, sub: `${kpi.revenue_achievement >= 80 ? "On Track" : "Below Target"}`, icon: Target, color: kpi.revenue_achievement >= 80 ? "text-cyan-400" : "text-amber-400", bg: kpi.revenue_achievement >= 80 ? "bg-cyan-500/10 border-cyan-500/20" : "bg-amber-500/10 border-amber-500/20" },
  { label: "Forecast Accuracy", value: `${kpi.forecast_accuracy}%`, sub: `MAPE: ${kpi.mape}%`, icon: BarChart3, color: "text-blue-400", bg: "bg-blue-500/10 border-blue-500/20" },
  { label: "Total Demand (YTD)", value: formatNum(kpi.total_demand), sub: `Forecast: ${formatNum(kpi.total_forecast)}`, icon: Package, color: "text-violet-400", bg: "bg-violet-500/10 border-violet-500/20" },
  { label: "Stock-out Risks", value: kpi.stockout_alerts_count, sub: `${kpi.products_count} products tracked`, icon: AlertTriangle, color: kpi.stockout_alerts_count > 3 ? "text-red-400" : "text-amber-400", bg: kpi.stockout_alerts_count > 3 ? "bg-red-500/10 border-red-500/20" : "bg-amber-500/10 border-amber-500/20" },
  { label: "Product Categories", value: kpi.categories_count, sub: `${kpi.products_count} active SKUs`, icon: Activity, color: "text-cyan-400", bg: "bg-cyan-500/10 border-cyan-500/20" },
];

export default function KPICards({ kpi }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-4" data-testid="kpi-cards">
      {cards(kpi).map((c, i) => (
        <div key={i} className={`rounded-xl border p-4 ${c.bg}`} data-testid={`kpi-card-${i}`}>
          <div className="flex items-center justify-between mb-3">
            <c.icon className={`w-4 h-4 ${c.color}`} />
          </div>
          <p className="text-xl font-bold text-white">{c.value}</p>
          <p className="text-[11px] text-slate-400 mt-0.5">{c.label}</p>
          <p className="text-[10px] text-slate-500 mt-1">{c.sub}</p>
        </div>
      ))}
    </div>
  );
}
